<template>
  <div>
    <CommunicationComposeModal v-if="showComposeModal" :communication="communication" @submit="reloadFilters" @close="closeCompose" />
    <CommunicationDetailModal v-if="showDetailModal && !!communication" :communication="communication" @communication-updated="reloadFilters" />

    <TitleBar>
      <template v-slot:title>
        {{ $gettext('Communication') }}
      </template>
      <template v-slot:buttons>
        <GekkoButton 
          :text="$gettext('New message')" 
          @click="composeClickHandler" 
          icon="fa fa-plus" 
        />
      </template>
    </TitleBar>
    <div class="content">
      <CommunicationsList ref="communication_list" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommunicationService from '@/store/services/communication.service.js'
import GekkoButton from '@/components/GekkoButton.vue'
import TitleBar from '@/components/TitleBar.vue'
import CommunicationComposeModal from '@/components/accountants/communication/compose/CommunicationComposeModal.vue'
import CommunicationDetailModal from '@/components/accountants/communication/CommunicationDetailModal.vue'
import CommunicationsList from '@/components/accountants/communication/CommunicationsList.vue'

export default {
  name: 'Communication',
  components: {
    CommunicationDetailModal,
    CommunicationComposeModal,
    TitleBar,
    GekkoButton,
    CommunicationsList
  },

  data() {
    return {
      communication: null,
      communications: [],
      fields: [
        { key: 'name', tdClass: 'col-comm-name' },
        { key: 'status', tdClass: 'col-comm-status' },
        { key: 'scheduled_at', tdClass: 'col-comm-scheduled-at' },
      ],
      currentFilters: null,
      status: 'loading',
      nextUrl: null,
      showDetailModal: false,
      showComposeModal: false,
      tableKey: 0,
    }
  },
  computed: {
    ...mapGetters({
      currentAccountantCompany: 'accountants/getCurrentAccountantCompany',
    }),
    isGekkoAccountant() {
      if (this.currentAccountantCompany.accountant_branding) return this.currentAccountantCompany.accountant_branding.is_gekko_accountant
      else return false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.showDetailModal = to.meta.showDetailModal
        this.showComposeModal = to.meta.showComposeModal

        if (this.$route.params['communication_id']) {
          this.getCommunication(this.$route.params['communication_id'])
        } else if (!from || to.params.filter_by !== from.params.filter_by) {
          this.reloadFilters()
        }
      },
    },
    '$route.params.communication_id'(newId, _) {
      if (newId) {
        this.getCommunication(newId)
      } else {
        this.communication = null
      }
    },
  },
  methods: {
    composeClickHandler() {
      this.$router.push({
        name: 'CommunicationCreate',
      })
    },
    getCommunication (comm_id) {
      this.status = 'loading'
      CommunicationService.byId(comm_id) // TODO rename byId to retrieve
        .then((response) => {
          this.communication = response.data
        })
        .finally(() => {
          this.status = 'idle'
        })
    },
    reloadFilters () {
      if (this.$refs['communication_list']) {
        this.$refs['communication_list'].refreshData()
        if (this.$route.params['communication_id']) {
          this.getCommunication(this.$route.params['communication_id'])
        }
      }
    },
    closeCompose () {
      this.$router.push({
        name: 'Communication',
        params: { filter_by: this.$route.params['filter_by'] }
      })
    }
  }
}
</script>

<style lang="scss">

</style>
